import React from 'react';

import { Link } from 'react-router-dom'
import { useEffect } from 'react';
import fencersSitting from "../imgs/fencersSitting23.png";
import foilFencers23 from "../imgs/foilFencers23.png";
import groupRunning23 from "../imgs/groupRunning23.png";
import stripCoaching from "../imgs/stripCoaching23.png";
import stretches23 from "../imgs/stretches23.png";
import sabre from "../imgs/sabre.png"; 
import coaching from "../imgs/coaching.png";           
import epeeBout from "../imgs/epee.png"
import epeeBouting from "../imgs/epeebouting.png";
import saberPractice from "../imgs/sabrePractice.png";
import saberPracticeBout from "../imgs/sabrePracticeBout.png"

export default function FencingCamp() {

	useEffect(() => {
		document.title = "Fencing Camp: RedPanda Fencing"
		window.scrollTo(0,0);
		
		// Load Instagram embed script for feed
		const script = document.createElement("script");
		script.src = "https://www.instagram.com/embed.js";
		script.async = true;
		
		if (!document.querySelector('script[src="https://www.instagram.com/embed.js"]')) {
			document.body.appendChild(script);
		}
		
		// Process embeds after script loads
		script.onload = () => {
			if ((window as any).instgrm) {
				(window as any).instgrm.Embeds.process();
			}
		};
	}, []);
	
	
	return <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">

		{/* Header Section */}
		<section className="text-center mb-8">
			<div className="bg-gradient-to-r from-tbtred to-red-800 text-white rounded-2xl p-6 md:p-8 max-w-4xl mx-auto shadow-lg">
				<h1 className="text-3xl md:text-4xl font-bold mb-3">Camp Dates: July 19th - 24th, 2026</h1>
				<h2 className="text-xl md:text-2xl font-semibold mb-4">Camp registration closes June 30, 2026!</h2>
			</div>
		</section>

		{/* Camp Types - Side by Side on Desktop */}
		<section className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8 max-w-4xl mx-auto">
			<div className="bg-white border-2 border-gray-200 rounded-2xl p-6 shadow-md text-center">
				<h3 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2">Summer Camp</h3>
				<p className="text-lg text-gray-600">Grades 9-12</p>
			</div>
			<div className="bg-white border-2 border-gray-200 rounded-2xl p-6 shadow-md text-center">
				<h3 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2">Junior Camp</h3>
				<p className="text-lg text-gray-600">Grades 2-8</p>
			</div>
		</section>
		
		{/* Sign Up and Meet Coaches Buttons */}
		<section className="text-center mb-8">
			<div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
				<Link 
					to="https://leagues.bluesombrero.com/redpandafencing" 
					className="inline-block bg-tbtred text-white text-2xl md:text-3xl font-bold px-8 py-4 rounded-xl border-4 border-white hover:bg-red-700 hover:scale-105 transition-all duration-200 shadow-lg" 
					target="_blank"
				>
					Sign Up for 2026 Camp!
				</Link>
				<Link 
					to="/coaches" 
					className="inline-block bg-white text-tbtred text-2xl md:text-3xl font-bold px-8 py-4 rounded-xl border-4 border-tbtred hover:bg-gray-50 hover:scale-105 transition-all duration-200 shadow-lg" 
				>
					Meet the Coaches
				</Link>
			</div>
		</section>

		{/* Instagram Section */}
		<section className="mb-8">
			<div className="bg-white border-2 border-gray-200 rounded-3xl p-6 md:p-8 shadow-lg max-w-2xl mx-auto">
				<h2 className="text-2xl md:text-3xl text-center font-bold mb-6 text-gray-800">Follow Us on Instagram</h2>
				<div className="flex justify-center items-center mb-4">
					<div 
						style={{
							border: "8px solid #B22222", 
							borderRadius: "1.5rem",
							overflow: "hidden",
							width: "100%",
							maxWidth: "600px",
							height: "600px",
							backgroundColor: "#fff",
							boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)"
						}}
					>
						<blockquote 
							className="instagram-media" 
							data-instgrm-permalink="https://www.instagram.com/red_panda_fencing/"
							data-instgrm-version="14"
							style={{
								background: "#FFF",
								border: "0",
								borderRadius: "3px",
								boxShadow: "0 0 1px 0 rgba(0,0,0,0.5), 0 1px 10px 0 rgba(0,0,0,0.15)",
								margin: "1px",
								maxWidth: "100%",
								minWidth: "326px",
								padding: "0",
								width: "100%",
								height: "100%"
							}}
						>
						</blockquote>
					</div>
				</div>
				<a 
					href="https://www.instagram.com/red_panda_fencing/" 
					target="_blank" 
					rel="noopener noreferrer"
					className="text-xl underline hover:text-tbtred inline-block text-center font-semibold text-gray-700 transition-colors duration-200"
				>
					View @red_panda_fencing on Instagram
				</a>
			</div>
		</section>

		{/* Image Gallery */}
		<section className="mb-8">
			<h2 className="text-2xl md:text-3xl text-center font-bold mb-6 text-gray-800">Images from our three discipline camp (2023)</h2>
			
			{/* Large Featured Images */}
			<div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-4">
				<img 
					src={fencersSitting} 
					className="w-full h-auto rounded-2xl border-4 border-tbtred shadow-lg object-cover" 
					alt="Fencers sitting" 
				/>
				<img 
					src={foilFencers23} 
					className="w-full h-auto rounded-2xl border-4 border-tbtred shadow-lg object-cover" 
					alt="Foil fencers" 
				/>
			</div>

			{/* Medium Images Grid */}
			<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
				<img 
					src={stripCoaching} 
					className="w-full h-auto rounded-2xl border-4 border-tbtred shadow-lg object-cover" 
					alt="Strip coaching" 
				/>
				<img 
					src={groupRunning23} 
					className="w-full h-auto rounded-2xl border-4 border-tbtred shadow-lg object-cover" 
					alt="Group running" 
				/>
				<img 
					src={epeeBouting} 
					className="w-full h-auto rounded-2xl border-4 border-tbtred shadow-lg object-cover" 
					alt="Epee bout" 
				/>
			</div>

			{/* Small Images Grid */}
			<div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
				<img 
					src={epeeBout} 
					className="w-full h-auto rounded-2xl border-4 border-tbtred shadow-lg object-cover" 
					alt="Epee bout" 
				/>
				<img 
					src={stretches23} 
					className="w-full h-auto rounded-2xl border-4 border-tbtred shadow-lg object-cover" 
					alt="Stretches" 
				/>
				<img 
					src={saberPracticeBout} 
					className="w-full h-auto rounded-2xl border-4 border-tbtred shadow-lg object-cover" 
					alt="Sabre practice bout" 
				/>
				<img 
					src={saberPractice} 
					className="w-full h-auto rounded-2xl border-4 border-tbtred shadow-lg object-cover" 
					alt="Sabre practice" 
				/>
			</div>

			{/* Final Two Images */}
			<div className="grid grid-cols-1 md:grid-cols-2 gap-4">
				<img 
					src={coaching} 
					className="w-full h-auto rounded-2xl border-4 border-tbtred shadow-lg object-cover" 
					alt="Coaching" 
				/>
				<img 
					src={sabre} 
					className="w-full h-auto rounded-2xl border-4 border-tbtred shadow-lg object-cover" 
					alt="Sabre" 
				/>
			</div>
		</section>

	</div>
}
